/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoyaltyRedemptionStatus } from './LoyaltyRedemptionStatus';
import {
    LoyaltyRedemptionStatusFromJSON,
    LoyaltyRedemptionStatusFromJSONTyped,
    LoyaltyRedemptionStatusToJSON,
} from './LoyaltyRedemptionStatus';

/**
 * A spin in the system health view, with the player's external ID.
 * @export
 * @interface RecentSpin
 */
export interface RecentSpin {
    /**
     * The prize name for a complete spin, or the error message for a failed one.
     * @type {string}
     * @memberof RecentSpin
     */
    details?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RecentSpin
     */
    resolvedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof RecentSpin
     */
    createdAt: Date;
    /**
     * 
     * @type {LoyaltyRedemptionStatus}
     * @memberof RecentSpin
     */
    status: LoyaltyRedemptionStatus;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof RecentSpin
     */
    gameId: string;
    /**
     * 
     * @type {string}
     * @memberof RecentSpin
     */
    playerLookupId: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof RecentSpin
     */
    id: string;
}



/**
 * Check if a given object implements the RecentSpin interface.
 */
export function instanceOfRecentSpin(value: object): value is RecentSpin {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('playerLookupId' in value) || value['playerLookupId'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function RecentSpinFromJSON(json: any): RecentSpin {
    return RecentSpinFromJSONTyped(json, false);
}

export function RecentSpinFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentSpin {
    if (json == null) {
        return json;
    }
    return {
        
        'details': json['details'] == null ? undefined : json['details'],
        'resolvedAt': json['resolvedAt'] == null ? undefined : (new Date(json['resolvedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'status': LoyaltyRedemptionStatusFromJSON(json['status']),
        'gameId': json['gameId'],
        'playerLookupId': json['playerLookupId'],
        'id': json['id'],
    };
}

export function RecentSpinToJSON(value?: RecentSpin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'details': value['details'],
        'resolvedAt': value['resolvedAt'] == null ? undefined : ((value['resolvedAt'] as any).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
        'status': LoyaltyRedemptionStatusToJSON(value['status']),
        'gameId': value['gameId'],
        'playerLookupId': value['playerLookupId'],
        'id': value['id'],
    };
}

